import httpClient from "../utils/httpClient";

export async function requestBusinessDemo(payload) {
  try {
    const res = await httpClient.post("/api/business/request-demo", payload);
    return res?.data ?? res;
  } catch (err) {
    const details = err?.response?.data?.details;
    if (Array.isArray(details) && details.length > 0) {
      const first = details[0];
      const message = first?.message || "Validation failed.";
      throw new Error(message);
    }

    const message =
      err?.response?.data?.error ||
      err?.message ||
      "Failed to submit demo request.";
    throw new Error(message);
  }
}
